<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button size="mini" type="primary" @click="search"> 搜索 </el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
    </customize-page>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import { mapGetters } from "vuex";

import douYinWarehouseFeeOrderApi from "@/api/douYinWarehouseFeeOrderApi";

export default {
  components: {
    CustomizePage
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["douYinWarehouseFeeOrderApi"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.filterObj = initParam.request.condition;
    }
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      columns: [
        {
          title: "货主ID",
          key: "customerId",
          align: "center"
        },
        {
          title: "仓租单号",
          key: "sourceNo",
          align: "center"
        },
        {
          title: "计费日期",
          key: "feeDate",
          align: "center"
        },
        {
          title: "状态",
          key: "status",
          align: "center",
          render: (h, params) => {
            const type = {
              INIT: "初始化",
              RETURN_SUCCESS: "回传成功",
              RETURN_FAIL: "回传失败"
            };
            return <div>{type[params.row.status]}</div>;
          }
        },
        {
          title: "创建时间",
          key: "gmtCreate",
          align: "center"
        }
      ],
      filterObj: {
        sourceNo: "",
        customerId: "",
        status: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      getCustomerList: "getCustomerList"
    })
  },
  methods: {
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();

      let searchCondition = {
        request: {
          ...filterParams,
          pageIndex: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }
      };

      douYinWarehouseFeeOrderApi
        .pageQuery(searchCondition)
        .then(res => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.page || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch(error => {
          this.$message.error(error.msg || "未知错误");
        });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },

    getFormConfig() {
      const type = this.getFormItemType();

      return [
        {
          data: [
            {
              label: "仓租单号",
              model: "sourceNo",
              type: type.INPUT
            },
            {
              label: "货主id",
              model: "customerId",
              type: type.SELECT,
              props: {
                data: this.getCustomerList
              }
            }
          ]
        }
      ];
    }
  }
};
</script>
